import React, { useEffect, useState } from 'react';
import { Label } from '../../../base';
import cs from 'classnames';
import TimeInput from 'components/TimeInput';
import useStyles from '../../useStyles';
import DateInput from 'components/core/DateInput';
import { getHours, getMinutes, isValid, set } from 'date-fns';
import { convertTimeObject, convertTo24HourFormat } from 'common/dateFormatConfig';
import { useTimeSettingsFormat } from 'common/useTimeSettingsFormat';
import { parseStringDate } from 'helpers/_date-helpers';

const TimeclockForm = ({ error, className, onChange, value: initialValue = {} }) => {
  const [clockIn, setClockIn] = useState(initialValue.clockIn);
  const [clockOut, setClockOut] = useState(initialValue.clockOut);
  const classes = useStyles();
  const { is12Format } = useTimeSettingsFormat()();

  useEffect(() => {
    onChange({ clockIn, clockOut });
  }, [clockIn, clockOut]);

  const toTime = (value) => {
    const date = value && parseStringDate(value);
    if (!isValid(date)) return undefined;
    return convertTimeObject({ hour: getHours(date), minute: getMinutes(date) }, is12Format);
  };

  const changeTime = (value, setValue) => ({ hour, minute, amPm }) => {
    const date = value && parseStringDate(value);
    const next = set(isValid(date) ? date : new Date(), {
      hours: is12Format ? convertTo24HourFormat(hour, amPm) : hour,
      minutes: minute,
    });
    if (isValid(next)) setValue(next);
  };

  return (
    <form className={cs(className, classes.root)}>
      <div className={classes.formTitle}>Clock-in</div>
      <div className={classes.form}>
        <label className={classes.field}>
          <Label>Date:</Label>
          <DateInput value={clockIn} onChange={(date) => setClockIn(new Date(date))} />
        </label>
        <label className={classes.field}>
          <Label>Time:</Label>
          <TimeInput value={toTime(clockIn)} onChange={changeTime(clockIn, setClockIn)} />
        </label>
      </div>
      <div className={classes.formTitle}>Clock-out</div>
      <div className={classes.form}>
        <label className={classes.field}>
          <Label>Date:</Label>
          <DateInput
            value={clockOut}
            onChange={(date) => setClockOut(date ? new Date(date) : null)}
          />
        </label>
        <label className={classes.field}>
          <Label>Time:</Label>
          <TimeInput value={toTime(clockOut)} onChange={changeTime(clockOut, setClockOut)} />
        </label>
        {error && (
          <div
            style={{
              color: '#DD6060',
              fontFamily: 'Open Sans',
              fontSize: 11,
              letterSpacing: '0.14px',
              lineHeight: '15px',
            }}
          >
            {error}
          </div>
        )}
      </div>
    </form>
  );
};

export default TimeclockForm;
